import React from "react";

const StylesComponent = ({ isDarkMode }) => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
        /* Table rounded corners fixes */
        .rounded-xl {
          border-radius: 0.75rem;
        }
        
        /* Scrollbar styles - theme-aware, visible on hover/scroll */
        .custom-scrollbar::-webkit-scrollbar { width: 8px; height: 8px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: ${isDarkMode ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.06)"}; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: ${isDarkMode ? "#444" : "rgba(0,0,0,0.2)"}; border-radius: 10px; }
        .custom-scrollbar:hover::-webkit-scrollbar-thumb,
        .custom-scrollbar:active::-webkit-scrollbar-thumb,
        .custom-scrollbar:focus::-webkit-scrollbar-thumb { background: ${isDarkMode ? "#555" : "rgba(0,0,0,0.3)"}; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #3B82F6; }
        .custom-scrollbar::-webkit-scrollbar-corner { background: transparent; }

        /* Hide scrollbars by default, show on hover/scroll */
        .custom-scrollbar { scrollbar-width: thin; scrollbar-color: ${isDarkMode ? "#444 rgba(0,0,0,0.3)" : "rgba(0,0,0,0.2) rgba(0,0,0,0.06)"}; }
        .custom-scrollbar:not(:hover):not(:focus):not(:active)::-webkit-scrollbar-thumb {
          background: transparent;
        }
        
        /* Add rounded corners to first and last cells in table */
        table tr:first-child th:first-child {
          border-top-left-radius: 0.75rem;
        }
        
        table tr:first-child th:last-child {
          border-top-right-radius: 0.75rem;
        }
        
        table tr:last-child td:first-child {
          border-bottom-left-radius: 0.75rem;
        }
        
        table tr:last-child td:last-child {
          border-bottom-right-radius: 0.75rem;
        }
        
        /* Set a default row height to prevent table jumping during refreshes */
        .table-row {
          height: 40px; /* Default row height */
        }

        /* Airtable-style left accent border on row hover */
        .table-row:hover {
          box-shadow: inset 3px 0 0 0 #3B82F6;
        }

        /* Selected row - persistent blue left border */
        .table-row-selected {
          box-shadow: inset 3px 0 0 0 #3B82F6;
        }
        
        /* Prevent table layout shifts during content changes */
        .table-wrapper {
          contain: strict;
          content-visibility: auto;
        }
        
        /* Animations */
        .animate-slideDown { 
          animation: slideDown 0.3s ease-out; 
        }
        
        @keyframes slideDown { 
          from { opacity: 0; transform: translateY(-10px); } 
          to { opacity: 1; transform: translateY(0); } 
        }
        
        /* Sidebar animations */
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        
        @keyframes slideOutRight {
          from { transform: translateX(0); }
          to { transform: translateX(100%); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        
        /* Sidebar transition classes */
        .translate-x-0 {
          animation: slideInRight 0.3s ease-out forwards;
        }
        
        .translate-x-full {
          animation: slideOutRight 0.3s ease-out forwards;
        }
        
        /* Overlay transition */
        .fixed.inset-0.bg-black\/50 {
          animation: fadeIn 0.3s ease-out forwards;
        }
        
        /* Button effect for sidebar toggle */
        .transform.scale-105 {
          transition: all 0.2s ease-out;
        }
        
        .animate-loader { 
          animation: pulse 1.5s infinite ease-in-out; 
        }
        
        @keyframes pulse { 
          0% { transform: scale(0.95); opacity: 0.7; } 
          50% { transform: scale(1.05); opacity: 1; } 
          100% { transform: scale(0.95); opacity: 0.7; } 
        }
        
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes scaleIn { 
          from { opacity: 0; transform: scale(0.95); } 
          to { opacity: 1; transform: scale(1); } 
        }
        
        /* Highlight new rows */
        @keyframes highlightRow {
          0% { background-color: ${isDarkMode ? "rgba(59, 130, 246, 0.3)" : "rgba(59, 130, 246, 0.2)"}; }
          100% { background-color: transparent; }
        }
        
        .animate-highlightRow {
          animation: highlightRow 2s ease-out forwards;
        }
        
        /* Add shadow to sidebar (always dark theme) */
        .fixed.right-0.top-0.bottom-0.w-64 {
          box-shadow: -5px 0 15px rgba(0,0,0,0.5);
        }
        
        /* Custom slider styles */
        .slider::-webkit-slider-thumb {
          appearance: none;
          height: 16px;
          width: 16px;
          border-radius: 50%;
          background: #FFAA00;
          cursor: pointer;
          border: 2px solid #fff;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        
        .slider::-moz-range-thumb {
          height: 16px;
          width: 16px;
          border-radius: 50%;
          background: #FFAA00;
          cursor: pointer;
          border: 2px solid #fff;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        `,
      }}
    />
  );
};

export default StylesComponent;
